import { fetchWrapper } from "../Helpers/fetch-wrapper";
import { toApiPage } from "./queryParams";

const filenameFromDisposition = (disposition) => {
  if (!disposition) return "";

  const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  if (encoded) {
    try {
      return decodeURIComponent(encoded).split(/[\\/]/).pop();
    } catch {
      return encoded.split(/[\\/]/).pop();
    }
  }

  return disposition.match(/filename="?([^";]+)"?/i)?.[1]?.split(/[\\/]/).pop() || "";
};

const getCsvs = async (
  page,
  pageSize,
  sortBy,
  sortOrder,
  filters
) => {
  let params = [];
  if (page || page === 0) params.push("page=" + toApiPage(page));
  if (pageSize) params.push("pageSize=" + pageSize);
  if (sortBy) params.push("sortBy=" + sortBy);
  if (sortOrder) params.push("sortOrder=" + sortOrder);
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        let param = "";
        param += `filters[${key}]=[`;
        let values = value.map((ele) => ele.id);
        values.join(",");
        param += values;
        param += `]`;
        params.push(param);
      } else if (typeof value == "string" && value) {
        params.push(`filters[${key}]=${value}`);
      }
    });
  }
  const response = fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/list-csv${
      params !== "" ? "?" + params.join("&") : ""
    }`
  );

  return response;
};

const deleteCsv = async (id) => {
  const response = fetchWrapper.delete(
    `${process.env.REACT_APP_API_ENDPOINT}/list-csv/${id}`
  );
  return response;
};

const downloadCsv = async (id, format, listedFilename) => {
  const url = `${process.env.REACT_APP_API_ENDPOINT}/list-csv/${id}/download`;

  const response = await fetchWrapper.getResponse(url);
  const blob = await response.blob();
  const urlObject = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = urlObject;

  const responseFilename = filenameFromDisposition(response.headers.get("content-disposition"));
  const storedFilename = listedFilename?.split(/[\\/]/).pop();
  const filename = responseFilename || storedFilename || `packs-export.${format === 'CSV' ? 'csv' : 'xlsx'}`;

  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(urlObject);
};


export const CsvService = {
  getCsvs,
  deleteCsv,
  downloadCsv
};
